// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity-container[data-v-46cb2742]{background:#fafafa;height:100vh;display:flex;justify-content:center;align-items:center;flex-direction:column}.activity-container img[data-v-46cb2742]{width:46.667vw}.activity-container .submit[data-v-46cb2742]{background:linear-gradient(93.3deg,#0057ff,#007eff);color:#fff;margin:25.067vw auto 0;width:75.733vw}.activity-container .error[data-v-46cb2742]{color:#ff2f2f}", ""]);
// Exports
module.exports = exports;
